import { AppConfig } from '../app-config'

const developmentConfig: AppConfig = {
  baseApiPath: 'http://localhost:21003',
  authenticatedRootUrl: '/home',
  unAuthenticatedRootUrl: '/login',
  authHost: 'http://localhost:21001',
  apmUrl: 'https://staging-apm.databiologics.com',
  tableauProductionBaseUrl: 'https://tableau.databiologics.com/',
  tableauProductionEmbeddedApiUrl:
    'https://tableau.databiologics.com/javascripts/api/tableau.embedding.3.latest.min.js',
  tableauStagingBaseUrl: 'https://tableau-staging.databiologics.com/',
  tableauStagingEmbeddedApiUrl:
    'https://tableau-staging.databiologics.com/javascripts/api/tableau.embedding.3.latest.min.js',
  googleMapsApiKey: 'AIzaSyDI2QYc4_MUQBPdgJeefb1sAQkEeAvf35g',
  stripePublictKey:
    'pk_test_51Mt0Y9Avm1kprluZY3C8E1ckDIwUgzJufUXnh7jCwT4YKC5P2rgAar1zlqdXDSPf6xIHHvtfQmXHZpOG0MKsEbdQ00UYx3BNJp',
  patientUrl: 'http://localhost:3002',
  cdnPath: 'https://staging-cdn.databiologics.com',
}

export default developmentConfig
